import { render, staticRenderFns } from "./TeachRoomPPT.vue?vue&type=template&id=371375bf&scoped=true&"
import script from "./TeachRoomPPT.vue?vue&type=script&lang=js&"
export * from "./TeachRoomPPT.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomPPT.vue?vue&type=style&index=0&id=371375bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371375bf",
  null
  
)

export default component.exports